import { render } from "./UsersList.vue?vue&type=template&id=620cadfe&scoped=true"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"

import "./UsersList.vue?vue&type=style&index=0&id=620cadfe&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-620cadfe"

export default script